import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { useRoute } from 'nuxt/app'

import { useCPNavigation } from '@common/navigation-layer/composables/useNavigationContext'

import { firstRouteValue, toEventDetailTabId } from '../utils/event-detail-tab'
import type { EventDetailSectionId } from '../types/event-detail'

export const useEventDetailTab = (defaultTab: MaybeRefOrGetter<EventDetailSectionId>) => {
  const route = useRoute()
  const { CPNavigateTo } = useCPNavigation()

  const speakerQueryId = computed(() => firstRouteValue(route.query.speaker))

  const preferredTab = computed(() => {
    if (speakerQueryId.value) return 'speakers'
    return toEventDetailTabId(route.hash) ?? toValue(defaultTab)
  })

  const selectTab = async (tabId: EventDetailSectionId) => {
    const eventId = firstRouteValue(route.params.eventId)
    if (!eventId) return

    try {
      await CPNavigateTo({
        name: 'clientportal-events-detail',
        params: { eventId },
        hash: tabId,
        options: { replace: true },
      })
    } catch (error) {
      console.error('[useEventDetailTab] Failed to select tab:', error)
    }
  }

  return {
    preferredTab,
    selectTab,
  }
}
